export const breakpoints = {
    tiny: '250px',
    tablet: '620px',
    desktop: '1024px',
    desktopLarge: '1920px',
};
export const PPUI_THEME_CLASSNAME = 'theme-ppui';
